.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  color: var(--color-grayscale-manatee);
  font-size: 1.2rem;
  font-weight: 400;
}
